<template>
  <VideoPlayer :options="videoOptions" />
</template>

<script>
import VideoPlayer from "@/components/VideoPlayer.vue";

export default {
  name: "App",
  components: {
    VideoPlayer,
  },
  data: () => ({
    videoOptions: {
      controls: true,
      aspectRatio: "16:9",
      sources: [],
      poster: "",
    },
  }),
  created() {
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);
    this.videoOptions.sources.push({
      src: params.get("play"),
    });
    this.videoOptions.poster = params.get("poster");
  },
};
</script>
